// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EoQ9F","label":"styles_label__n9OAF","select":"styles_select__PP0c-"};